/**
 * GET /api/notifications/preferences — current user's notification preferences.
 *
 * Used by useNotificationPreferences hook. Replaces ad-hoc defaults
 * `{ emailEnabled: true, mutedTypes: [] }` for legacy parity.
 */
import { z } from 'zod';

export const NotificationPreferencesSchema = z.looseObject({
  emailEnabled: z.boolean(),
  mutedTypes: z.array(z.string()),
  digestFrequency: z.string().optional(),
  updatedAt: z.string().optional(),
});

export type NotificationPreferences = z.infer<
  typeof NotificationPreferencesSchema
>;

export const NotificationPreferencesResponseSchema = z.union([
  z.looseObject({ preferences: NotificationPreferencesSchema }),
  NotificationPreferencesSchema,
]);

export type NotificationPreferencesResponse = z.infer<
  typeof NotificationPreferencesResponseSchema
>;
